export { getVirtualParent } from '@fluentui/dom-utilities';
//# sourceMappingURL=getVirtualParent.js.map